import { createContext } from "react";

const context = createContext();
context.displayName = "translations";

export default context;
